import { App } from '@capacitor/app';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { isNativeApp, isIOS } from '../utils/platform.js';
import { goNativeTab } from './NativeTabContext';
import { OPEN_DAILY_PAPER_EVENT } from '../utils/paperCache';

let initialized = false;

function handleDeepLink(rawUrl) {
  const url = String(rawUrl || '');
  const lower = url.toLowerCase();
  if (lower.includes('://paper') || lower.endsWith('/paper') || lower.includes('open=paper')) {
    goNativeTab('paper');
    window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent(OPEN_DAILY_PAPER_EVENT, { detail: {} }));
    }, 120);
    return true;
  }
  if (url.includes('/story/') || url.includes('story=')) {
    if (/^\/story\//.test(window.location.pathname) || window.location.search.includes('story=')) {
      window.history.replaceState({}, '', '/');
    }
    window.dispatchEvent(new Event('rk-close-story'));
    return true;
  }
  return false;
}

export async function initMobileShell() {
  if (!isNativeApp() || initialized) return;
  initialized = true;

  document.documentElement.classList.add('is-native-app');
  if (isIOS()) document.documentElement.classList.add('is-ios');

  if (/^\/story\//.test(window.location.pathname) || window.location.search.includes('story=')) {
    window.history.replaceState({}, '', '/');
  }

  try {
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.setStyle({ style: Style.Light });
    await StatusBar.setBackgroundColor({ color: '#1a6b2f' });
  } catch {
    /* ignore — web */
  }

  try {
    await SplashScreen.hide();
  } catch {
    /* ignore */
  }

  try {
    await Keyboard.setAccessoryBarVisible({ isVisible: true });
  } catch {
    /* ignore */
  }

  const stripStoryRoute = () => {
    if (/^\/story\//.test(window.location.pathname) || window.location.search.includes('story=')) {
      window.history.replaceState({}, '', '/');
    }
  };

  try {
    App.addListener('appStateChange', ({ isActive }) => {
      stripStoryRoute();
      if (!isActive) {
        window.dispatchEvent(new Event('rk-close-story'));
      }
    });

    App.addListener('appUrlOpen', (event) => {
      handleDeepLink(event?.url);
    });

    App.addListener('backButton', ({ canGoBack }) => {
      window.dispatchEvent(new Event('rk-native-back'));
      if (document.querySelector('.ios-sheet')) return;
      if (canGoBack) {
        window.history.back();
        return;
      }
      App.exitApp();
    });

    const launch = await App.getLaunchUrl().catch(() => null);
    if (launch?.url) handleDeepLink(launch.url);
  } catch {
    /* ignore — web / missing plugin */
  }
}
